class BonusGameData extends SlotGame.src.store.BonusGameData {
    public totalBonusWin: number = 0;

    public reset() {
        super.reset();

        this.totalBonusWin = 0;
    }
}

export { BonusGameData };

SlotGame.src.store.BonusGameData = BonusGameData;